import { createEntityCollectionStore, type PickActions } from '@core/ngrx-legacy';
import type { ThreadSummary } from '@core/tellent-assistant-types';

const idSelector = (thread: ThreadSummary) => thread.id;

const { selectors, reducer, actions, namespace } = createEntityCollectionStore<ThreadSummary>()(
  'TellentAssistantThreads',
  { idSelector },
);

const TellentAssistantThreadsActions: PickActions<
  typeof actions,
  'fetchCollection' | 'removeOnePessimistic'
> = actions;

export {
  selectors as TellentAssistantThreadsSelectors,
  reducer as TellentAssistantThreadsReducer,
  TellentAssistantThreadsActions,
  namespace as TellentAssistantThreadsNamespace,
};
